import styled from "styled-components";

import { colors } from "../common/element/elements.js";
import backgrounimg from "../../politicalimgeas/backgrounds/background1.jpg";

export const Styles = styled.div` .top-bar2 {
    height: 40px;

    border-bottom: 1px solid $ {
        colors.border1
    }

    ;

    .bar-left {
        a margin-top: 4px;

        ul {
            li {
                font-size: 14px;

                color : $ {
                    colors.text2
                }

                ;
                margin-right: 20px;
                display : inline-block;

                i {
                    font-size: 18px;

                    color : $ {
                        colors.green
                    }

                    ;
                    vertical-align: text-bottom;
                    margin-right : 5px;

                    @media(max-width: 1199px) {
                        margin-right: 2px;
                    }
                }

                @media(max-width: 1199px) {
                    margin-right: 8px;
                }

                @media(max-width: 991px) {
                    font-size: 13px;
                }
            }
        }
    }

    .bar-right {
        margin-top: 6px;

        ul.bar-lang {
            margin-right: 30px;
            position: relative;
            margin-top: 3px;

            &::before {
                position: absolute;
                content: "";

                background: $ {
                    colors.border1
                }

                ;
                width : 1px;
                height : 20px;
                top : 0;
                right : -15px;
            }

            li {
                .dropdown {
                    button.dropdown-toggle {
                        font-size: 13px;

                        color : $ {
                            colors.text2
                        }

                        ;
                        background: transparent;
                        border : none;
                        padding : 0;
                        box-shadow: none;

                        img {
                            margin-right: 5px;
                            max-width: 21px;
                        }

                        i {
                            font-size: 12px;
                            margin-left: 3px;
                        }

                        &::after {
                            display: none;
                        }

                        &:hover {
                            cursor: pointer;

                            color : $ {
                                colors.green
                            }

                            ;
                        }
                    }

                    ul.dropdown-menu {
                        padding: 0;
                        margin: 0;
                        border: none;
                        background-color: #ffffff;
                        border-radius: 5px;
                        top: 50% !important;
                        left: -16px !important;
                        box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);

                        li {
                            display: block;

                            border-bottom: 1px solid $ {
                                colors.border1
                            }

                            ;
                            padding : 7px 15px;

                            color : $ {
                                colors.text3
                            }

                            ;
                            cursor : pointer;

                            img {
                                max-width: 21px;
                                margin-right: 5px;
                            }

                            &:hover {
                                color : $ {
                                    colors.black1
                                }

                                ;
                                font-weight : 500;
                                background-color: transparent;
                            }

                            &:last-child {
                                border-bottom: none;
                            }
                        }
                    }
                }
            }
        }

        ul.bar-social {
            margin-right: 30px;
            position: relative;

            &::before {
                position: absolute;
                content: '';

                background: $ {
                    colors.border1
                }

                ;
                width : 1px;
                height : 20px;
                top : 3px;
                right : -15px;
            }

            li {
                a {
                    font-size: 13px;

                    color : $ {
                        colors.green
                    }

                    ;

                    background : $ {
                        colors.border1
                    }

                    ;
                    display : inline-block;
                    width : 25px;
                    height : 25px;
                    text-align : center;
                    padding-top: 3px;
                    border-radius : 5px;

                    &:hover {
                        background: $ {
                            colors.green
                        }

                        ;
                        color : #ffffff;
                    }
                }

                &:last-child {
                    a {
                        margin-right: 0;
                    }
                }
            }

            
        }

        ul.sidebar-button {
            li.side-box {
                a.nav-link {
                    font-size: 20px;
                    padding: 0;
                    line-height: 28px;

                    i {
                        color : $ {
                            colors.green
                        }

                        ;
                    }
                }
            }
        }
    }

    @media(max-width: 767px) {
        display: none;
    }
        padding:0 10px;
}

.logo-area2 {
    // height     : 82px;
    // padding:0 15px;
    box-shadow: 0 8px 20px 5px rgba(0, 0, 0, 0.07);
    z-index: 999;
    .nav-bg {
        background-image: url(../../politicalimgeas/backgrounds/background1.jpg);
    }


    .logo {

        width: 200px;
        a {
            img {
                width:140px;
                @media(max-width: 991px) {
                    max-width: 100%;
                }
            }
        }
    }


    .dropdown-wrapper {
  position: relative;
  display: inline-block;
  display:flex;
    align-items:center;

  .menu-button {
    background-color: #fff7f0;
    border: 2px solid rgb(255, 227, 136);
    padding: 6px 15px;
    border-radius: 999px;

    cursor: pointer;
    font-weight: 600;
    color: rgb(190, 156, 0);
    transition: background-color 0.3s ease, color 0.3s ease;
    

    &:hover {
      background-color: rgb(252, 239, 182);
      color: rgb(36, 35, 35);
    }
  }

  .dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 0px;
    background: white;
    border: 1px solid #ffddc2;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(255, 165, 0, 0.2);
    z-index: 1000;
    min-width: 220px;
    padding: 5px 0px;
    display: none;

    .dropdown-item {
      position: relative;
      padding: 6px 15px;
      cursor: pointer;
      font-weight: 500;
      color:rgb(190, 156, 0);
      border-radius: 999px;
      transition: background-color 0.3s ease;
      display:flex;
      align-items:center;

      &:hover {
        background-color: #fff0e0;
        color:#333;
      }

      .arrow {
        margin-left: auto;
        font-size: 0.8rem;
      }

      &.has-submenu {
        &:hover {
          .submenu {
            display: block;
            opacity: 1;
            transform: translateX(0);
          }
        }

        .submenu {
          position: absolute;
          left: 100%;
          top: 0;
          display: none;
          opacity: 0;
          transition: all 0.3s ease;
          background:rgb(255, 254, 251);
          border: 1px solid #ffddc2;
          border-radius: 12px;
          min-width: 200px;
          padding: 8px 0;
          box-shadow: 0 4px 12px rgba(255, 153, 51, 0.2);

          .submenu-item {
            padding: 10px 20px;
            border-radius: 999px;
            margin: 4px 12px;
            color:rgb(190, 156, 0);
            font-weight: 500;
            transition: background-color 0.3s ease;

            &:hover {
              background-color:rgb(255, 251, 214);
              color:rgb(41, 41, 41);
            }
          }
        }
      }
    }
  }

  &:hover {
    .dropdown {
      display: block;
    }
  }
}





//    .dropdown-wrapper {
//   position: relative;
//   display: inline-block;

//   .menu-button {
//     background-color: #fff7f0;
//     border: 2px solid rgb(255, 227, 136);
//     padding: 12px 20px;
//     border-radius: 999px;
//     cursor: pointer;
//     font-weight: 600;
//     color: rgb(190, 156, 0);
//     transition: background-color 0.3s ease, color 0.3s ease;

//     &:hover {
//       background-color: rgb(252, 239, 182);
//       color: rgb(36, 35, 35);
//     }
//   }

//   &:hover .dropdown {
//     display: block;
//   }

//   .dropdown {
//     position: absolute;
//     top: 100%;
//     left: 0;
//     background: white;
//     border: 1px solid #ffddc2;
//     border-radius: 10px;
//     box-shadow: 0 4px 16px rgba(255, 165, 0, 0.2);
//     z-index: 1000;
//     min-width: 220px;
//     padding: 5px 0;
//     display: none;
//     max-height: 400px;
//     overflow-y: auto;

//     &::-webkit-scrollbar {
//       width: 6px;
//     }
//     &::-webkit-scrollbar-track {
//       background: #f1f1f1;
//       border-radius: 3px;
//     }
//     &::-webkit-scrollbar-thumb {
//       background: rgb(255, 227, 136);
//       border-radius: 3px;
//     }

//     .dropdown-item {
//       position: relative;
//       padding: 8px 20px;
//       cursor: pointer;
//       font-weight: 500;
//       color: rgb(190, 156, 0);
//       border-radius: 999px;
//       transition: background-color 0.3s ease;
//       display: flex;
//       align-items: center;

//       &:hover {
//         background-color: #fff0e0;
//         color: #333;
//       }

//       .arrow {
//         margin-left: auto;
//         font-size: 0.8rem;
//       }

//       &.has-submenu {
//         &:hover .submenu {
//           display: block;
//         }

//         .submenu {
//           position: absolute;
//           left: 100%;
//           top: 0;
//           background: white;
//           border: 1px solid #ffddc2;
//           border-radius: 10px;
//           box-shadow: 0 4px 16px rgba(255, 165, 0, 0.2);
//           z-index: 1001;
//           min-width: 220px;
//           padding: 5px 0;
//           display: none;
//           max-height: 400px;
//           overflow-y: auto;

//           &::-webkit-scrollbar {
//             width: 6px;
//           }
//           &::-webkit-scrollbar-track {
//             background: #f1f1f1;
//             border-radius: 3px;
//           }
//           &::-webkit-scrollbar-thumb {
//             background: rgb(255, 227, 136);
//             border-radius: 3px;
//           }

//           .submenu-item {
//             padding: 10px 20px;
//             border-radius: 999px;
//             margin: 4px 12px;
//             color: rgb(190, 156, 0);
//             font-weight: 500;
//             transition: background-color 0.3s ease;
//             cursor: pointer;

//             &:hover {
//               background-color: rgb(255, 251, 214);
//               color: rgb(41, 41, 41);
//             }
//           }
//         }
//       }
//     }
//   }
// }

    div.menu-box {
        ul.nav.menu-nav {
            .trainingreg {
                position: relative;
                background: #eaebdc;
                color: #000000;
                padding: 7px 20px;
                font-size: 18px;
                border-radius: 20px;
                cursor: pointer;
                margin-left: 10px;
                
                @media(max-width: 1340px) {
                    padding: 8px 10px;
                   font-size: 12px;
                }
            }

            .Login {
                position: relative;
                background: #eaebdc;
                color: #000000;
                width: 150px;
                height: 45px;
                top: 50%;
                border-radius: 25px;
                padding-left: 62px;
                font-size: 16px;
                line-height: 1.5;
                z-index: 4;
                cursor: pointer;
                @media(max-width: 1340px) {
                   font-size: 12px;
                   width: 120px;
                    text-align: center;
                    height: 35px;
                }
            }

            .Signin {
                position: relative;
                background-color: rgb(222, 176, 78) !important;
                color: #fff;
                width: 110px;
                text-align: center;
                height: 45px;
                top: 50%;
                border-radius: 25px;
                margin-right: -65px;
                font-size: 16px;
                line-height: 1.5;
                z-index: 5;
                cursor: pointer;
                @media(max-width: 1340px) {
                    font-size: 12px;
                    width: 80px;
                    text-align: center;
                    height: 35px;
                    margin-right: -60px;
                }
            }

            .user {
                position: relative;
                background: #eaebdc;
                color: #000000;
                text-shadow: 1px 2px 3px white;
                text-align: center;
                padding: 5px 25px;
                padding-left: 10px;
                font-size: 16px;
                line-height: 1.5;
                z-index: 5;
                cursor: pointer;
                .profileimg {
                    width: 35px;
                    height:35px;
                }
                @media(max-width: 1340px) {
                   font-size: 12px;
                   padding: 5px 20px;
                   padding-left: 5px;
                        .profileimg {
                            width: 25px;
                            height:25px;
                        }
                }
            }

            

            .Signin:hover {
                background-color: rgb(249, 176, 42) !important;
                color: white !important;
            }

            .user:hover {
                background-color: rgb(249, 176, 42) !important;
                color: white !important;
                text-shadow: 1px 2px 3px gray;
            }

            .Login:hover {
                background-color: rgb(249, 176, 42) !important;
                color: white !important;
            }

            .trainingreg:hover {
                background-color: rgb(249, 176, 42) !important;
                color: white !important;
            }


            li.nav-item {
                position: relative;

                a.nav-link {
                    font-size: 14px;
                    color: #fff;
                    text-transform: uppercase;
                    font-weight: 500;
                    // padding       : 10px 10px 20px;
                    padding: 10px 20px;

                    i {
                        font-size: 12px;
                    }

                    &:after {
                        content: none;
                    }

                    &:hover {
                        // color: ${colors.green};
                        color: #000000;
                        background: #ffcc04;
                        border-radius: 5px;
                        transition: .5s;
                    }

                    @media(max-width: 1340px) {
                        font-size: 12px;
                        padding: 5px 10px;
                    }

                    @media(max-width: 1199px) {
                        // padding: 10px 2px 20px;
                        // padding: 10px;
                        letter-spacing: 0;
                    }
                }

                .allprograms {
                    font-size: 14px;
                    color: #fff;
                    padding: 10px 25px;
                    margin: 0;
                    border: none;
                    @media(max-width: 1340px) {
                        padding: 10px 10px;
                        font-size: 12px;
                    }
                }

                .allprograms:hover {
                    color: #000000;
                    background: #ffcc04;
                    border-radius: 5px;
                    transition: .5s;

                }

                ul.dropdown {
                    position: absolute;
                    left: 0;
                    top: 100%;
                    min-width: 190px;
                    background: #fff;

                    border : 1px solid $ {
                        colors.border1
                    }

                    ;
                    text-align: left;
                    padding : 0;
                    border-radius : 5px;
                    transition : 0.2s ease;
                    opacity : 0;
                    transform : scaleY(0);
                    visibility : hidden;
                    z-index : 999;
                    transform-origin: center top 0;

                    li.nav-item {



                        position: relative;

                        a.nav-link {
                            font-size: 13px;

                            color : $ {
                                colors.text1
                            }

                            ;
                            padding : 10px 20px;
                            text-transform: capitalize;
                            font-weight : 400;
                            margin-right : 0;

                            border-bottom : 1px solid $ {
                                colors.border1
                            }

                            ;

                            &:hover {
                                color: $ {
                                    colors.green
                                }

                                ;

                                i {
                                    color: #fff;
                                }
                            }

                            i {
                                float: right;
                                margin-top: 4px;
                            }
                        }

                        &:last-child {
                            margin-left: 0;

                            a.nav-link {
                                border-bottom: none;
                            }
                        }

                        ul.dropdown2 {
                            position: absolute;
                            top: 0;
                            left: 100%;
                            min-width: 180px;
                            background: #fff;

                            border : 1px solid $ {
                                colors.border1
                            }

                            ;
                            transition : 0.2s ease;
                            opacity : 0;
                            transform : scaleY(0);
                            visibility : hidden;
                            z-index : 999;
                            transform-origin: center top 0;
                        }

                        &:hover {
                            ul.dropdown2 {
                                opacity: 1;
                                transform: scaleY(1);
                                visibility: visible;
                            }
                        }
                    }
                }

                &:hover {
                    ul.dropdown {
                        opacity: 1;
                        transform: scaleY(1);
                        visibility: visible;
                    }
                }
            }
           
        }
            



        .search-box {
            margin-left: 18px;
            margin-top: 11px;

            a {
                padding: 0;

                i {
                    font-size: 18px;

                    color : $ {
                        colors.green
                    }

                    ;
                }
            }

            i.close-btn {
                position: absolute;
                top: 25px;
                right: -12px;
                font-size: 26px;

                color : $ {
                    colors.green
                }

                ;
                cursor : pointer;
            }

            @media(max-width: 1199px) {
                margin-left: 5px;
            }
        }

        .apply-btn {
            margin-left: 70px;
            margin-top: -1px;

            a {
                font-size: 13px;
                color: #ffffff;

                background : $ {
                    colors.gr_bg
                }

                ;
                display : inline-block;
                width : 110px;
                height : 40px;
                text-align : center;
                text-transform: uppercase;
                font-weight : 500;
                padding : 11px;
                border-radius : 0 5px 5px 0;
                position: relative;

                i {
                    position: absolute;
                    font-size: 20px;
                    left: -40px;
                    top: 0;
                    padding: 10px;
                    width: 40px;
                    height: 100%;
                    border-radius: 5px 0 0 5px;

                    background-color: $ {
                        colors.green2
                    }

                    ;
                }

                &:hover {
                    background: $ {
                        colors.gr_bg2
                    }

                    ;
                }
            }

            @media(max-width: 991px) {
                display: none;
            }
        }
    }

    @media(max-width: 767px) {
        display: none;
    }


}

@media (max-width: 991px) {

    .logo-area2 {
        display:none; 
    }
}

.jobs {
        /* Ensure cursor is a pointer on dropdown buttons */
    .allprograms,
    .dropdown-item {
        cursor: pointer;
    }

    /* Ensure dropdown opens on hover */
    .nav-item.dropdown:hover > .dropdown-menu {
        display: block;
       
    }
   

    /* Style for active dropdown button */
    .allprograms:hover, 
    .allprograms:focus, 
    .dropdown-item:hover {
        background-color:rgb(255, 196, 0) !important;
        color: white !important;
    }

    /* Submenu styling */
    .dropdown-submenu {
        position: relative;
    }

    .dropdown-submenu .dropdown-menu {
        left: 100%;
        top: 0;
        display: none;
        margin-top: -37px;
    }

    /* Show sub-dropdown on hover */
    .dropdown-submenu:hover > .dropdown-menu {
        display: block;
        animation: fadeIn 0.3s ease-in-out;
    }

    /* Change cursor to pointer for submenus */
    .dropdown-submenu > .dropdown-toggle {
        cursor: pointer;
    }

}

.profile {
    font-size: 14px;

    color : $ {
        colors.black1
    }

    ;
    text-transform: uppercase;
    font-weight : 500;
    padding : 10px 30px 10px;

}

.profile2 {
    border-bottom: 1px solid $ {
        colors.border1
    }

    ;

}

.signin {
    margin-right: 5px
}

.login-div {

    border-radius: 20px;

    font-size: 14px;

    color : $ {
        colors.black1
    }

    ;
    text-transform: uppercase;
    font-weight : 500;
    padding : 10px 20px;


}

.notify {
    overflow: hidden;

    i {
        font-size: 20px;
        margin-right: 10px;
        cursor: pointer;
    }

    i:hover {
        color: orange;
        trastiotion: .5s;
    }

}

.tooltip1 {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip1 .tooltiptext1 {
    width: 120px;
    top: 100%;
    left: 33%;
    margin-left: -60px;
    visibility: hidden;
    width: 100%;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip1 */
    position: absolute;
    z-index: 111;
}

.tooltip1:hover .tooltiptext1 {
    visibility: visible;
    z-index: 111;
}






@media(max-width: 1340px) {
    .logo-area2 {
        .logo {
            width: 140px;
        }



    }
}

`;
